/**
 * @file Consts for date related
 */

export const TIME_FORMAT = 'YYYY-MM-DD';
export const FULL_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const NEW_TIME_FORMAT = 'YYYY/MM/DD';
export const TIME_FORMAT_DETAIL = 'YYYY-MM-DD HH:mm:ss';
export const DECIMAL_LENGTH = 2;

export const EnumRangeType = {
  LAST_SEVEN_DAYS: {
    key: 'common_date_last_seven', // key in translation json
    val: '1',
  },
  TODAY: {
    key: 'common_date_today',
    val: '6',
  },
  YESTERDAY: {
    key: 'common_date_yesterday',
    val: '7',
  },
  LAST_THREE_DAYS: {
    key: 'automated_rules_time_range_recent_3_days',
    val: '33',
  },
  LAST_THIRTY_DAYS: {
    key: 'common_date_last_thirty',
    val: '2',
  },
  LAST_MONTH: {
    key: 'common_date_last_month',
    val: '3',
  },
  THIS_MONTH: {
    key: 'common_date_this_month',
    val: 'THIS_MONTH',
  },
  LAST_THREE_MONTH: {
    key: 'common_date_last3_month',
    val: 'LAST_THREE_MONTH',
  },
  LAST_QUARTER: {
    key: 'common_date_last_quarter',
    val: '4',
  },
  LAST_FOURTEEN_DAYS: {
    key: 'common_date_last_fourteen',
    val: 'LAST_FOURTEEN_DAYS',
  },
  THIS_WEEK: {
    key: 'common_date_this_week',
    val: 'THIS_WEEK',
  },
  LAST_WEEK: {
    key: 'common_date_last_week',
    val: 'LAST_WEEK',
  },
  CUSTOM: {
    key: 'common_date_custom_range',
    val: '5',
  },
  LIFETIME: {
    key: 'common_lifetime',
    val: 'LIFETIME',
  },
  TWENTY_EIGHT: {
    key: 'common_date_last_twenty_eight',
    val: 'TWENTY_EIGHT',
  },
};

export const EnumLifetimeType = {
  chosen: 1,
  unchosen: 0,
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
